import axios from 'axios';
import { authHeader } from './auth-header';

export const rejectReasonService = {
    getAll,
    create,
    update,
    destroy
};

function getAll({ 
    pageSize, 
    page, 
    search, 
    orderBy, 
    sortColumn  
}) {
    return axios.get('/reject_reason', {
        params: {
            pageSize,
            page,
            search,
            orderBy,
            sortColumn
        },
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function create(data) {
    return axios.post('/reject_reason', data, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function update(data) {
    return axios.put(`/reject_reason/${data.id}`, data, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function destroy(id) {
    return axios.delete(`/reject_reason/${id}`, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}